// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1rgP_","lastUpdated":"TermsOfService_lastUpdated__3dxla","enphasis":"TermsOfService_enphasis__9X-QW"};